export default {
      id: "oc-res-k8s-federatedclusterrole-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-k8s-federatedclusterrole",
      toString: function () {
        return this.url;
      }
    }